import { Component, OnInit, Input } from '@angular/core';

import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-customer-page-updates',
  templateUrl: './customer-page-updates.component.html',
  styleUrls: ['./customer-page-updates.component.sass']
})
export class CustomerPageUpdatesComponent implements OnInit {

  @Input() customerId: string;

  public columns: Array<any> = [
    {
      title: 'Package Name',
      name: 'Pack_Name',
      sort: '',
      filtering: {
        filterType: 'text',
        placeholder: 'Filter by name'
      },
      width: '320px'
    },
    {
      title: 'Package Version',
      name: 'Version',
      sort: '',
      filtering: {
        filterType: 'text',
        placeholder: 'Filter by version'
      }
    },
    {
      title: 'Status',
      name: 'StateTitle',
      cellClassName: ['btn-link cursor-pointer'],
      sort: '',
      filtering: {
        filterType: 'text',
        placeholder: 'Filter by status'
      }
    },
    {
      title: 'Update Date',
      name: 'ReportDate',
      type: 'date',
      sort: 'desc',
      filtering: {
        filterType: 'daterange',
        maxDate: new Date(),
        placeholder: 'Filter by date'
      }
    }
  ];

  public config: any = {
    paging: true,
    sorting: { columns: this.columns },
    className: ['table-striped', 'table-bordered'],
    filtering: { filterString: '' }
  };

  public updatesData: Array<any> = [];

  constructor(private api: ApiService) { }

  ngOnInit(): void {
    this.api.get(`customers/${this.customerId}/updatereport`, (result: Array<any>) => {
      this.updatesData = result;
    });
  }

  public onCellClick(cell: any): any {
    switch (cell.column.name) {
      case 'StateTitle':
        const { DumpFileID } = cell.row;
        this.api.download(
          `customers/${this.customerId}/${DumpFileID}/GetReportFiles`,
          `${DumpFileID}.zip`
        );
        break;
      default:
        break;
    }
  }

}
